/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext } from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { AdminRoutePath } from "./routePath";
import { NotFound } from "#pages";
import { Sidebar, SidebarTab } from "#components";
import { AuthContext } from "#contexts/authContext.jsx";
import adminSidebarConfig from "#constants/adminSidebarConfig.js";

export default function AdminRouter() {
  const { isAuthenticated } = useContext(AuthContext);

  const PublicRoute = () => {
    if (isAuthenticated === true) {
      return <Navigate to={AdminRoutePath.DASHBOARD.path} replace />;
    }
    return <Outlet />;
  };

  const ProtectedRoute = () => {
    if (isAuthenticated === false) {
      return <Navigate to={"/"} />;
    }
    return (
      <>
        <Sidebar>
          {adminSidebarConfig().map((item) => (
            <SidebarTab data={item} />
          ))}
        </Sidebar>
        <Outlet />
      </>
    );
  };

  return (
    <Routes>
      <Route element={<PublicRoute />}>
        <Route index element={AdminRoutePath.SPLASH.component} />
        <Route
          path={AdminRoutePath.SPLASH.path}
          element={AdminRoutePath.SPLASH.component}
        />
        <Route
          path={AdminRoutePath.LOGIN.path}
          element={AdminRoutePath.LOGIN.component}
        />
      </Route>
      <Route element={<ProtectedRoute />}>
        <Route
          path={AdminRoutePath.DASHBOARD.path}
          element={AdminRoutePath.DASHBOARD.component}
        />
        <Route
          path={AdminRoutePath.PROFILE.path}
          element={AdminRoutePath.PROFILE.component}
        />
        <Route
          path={AdminRoutePath.CHANGE_PASSWORD.path}
          element={AdminRoutePath.CHANGE_PASSWORD.component}
        />
        {/* AGRONOMIST ROUTES */}
        <Route
          path={AdminRoutePath.AGRONOMIST_MANAGEMENT.path}
          element={AdminRoutePath.AGRONOMIST_MANAGEMENT.component}
        />
        <Route
          path={AdminRoutePath.AGRONOMIST_DETAIL.path}
          element={AdminRoutePath.AGRONOMIST_DETAIL.component}
        />
        {/* SCOUTING ROUTES */}
        <Route
          path={AdminRoutePath.SCOUTING_MANAGEMENT.path}
          element={AdminRoutePath.SCOUTING_MANAGEMENT.component}
        />
        <Route
          path={AdminRoutePath.SCOUTING_DETAIL.path}
          element={AdminRoutePath.SCOUTING_DETAIL.component}
        />
        {/* CROP ROUTES */}
        <Route
          path={AdminRoutePath.CROP_MANAGEMENT.path}
          element={AdminRoutePath.CROP_MANAGEMENT.component}
        />
        {/* CROP PLAN ROUTES */}
        <Route
          path={AdminRoutePath.CROP_PLAN_MANAGEMENT.path}
          element={AdminRoutePath.CROP_PLAN_MANAGEMENT.component}
        />
        <Route
          path={AdminRoutePath.CROP_PLAN_DETAIL.path}
          element={AdminRoutePath.CROP_PLAN_DETAIL.component}
        />
        {/* GROWERS ROUTES */}
        <Route
          path={AdminRoutePath.GROWERS_MANAGEMENT.path}
          element={AdminRoutePath.GROWERS_MANAGEMENT.component}
        />
        <Route
          path={AdminRoutePath.GROWERS_DETAIL.path}
          element={AdminRoutePath.GROWERS_DETAIL.component}
        />
        {/* PRODUCT ROUTES */}
        <Route
          path={AdminRoutePath.PRODUCT_MANAGEMENT.path}
          element={AdminRoutePath.PRODUCT_MANAGEMENT.component}
        />
        {/* CONTENT ROUTES */}
        <Route
          path={AdminRoutePath.CONTENT_MANAGEMENT.path}
          element={AdminRoutePath.CONTENT_MANAGEMENT.component}
        />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
